











































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import ActionCol from '@/views/AiiTasks/actionCol.vue'
import RevisitAction from '@/views/returnVisit/actionCol.vue'
import { injuryColumns as columns } from './config'
import { getTaskType } from '@/utils/order'
import WholeProcessApi from '@/api/wholeProcess'
import RevisitApi from '@/api/revisit'
import addResurvey from '@/views/returnVisit/addResurvey/addResurvey.vue'
import addMotion from '@/views/returnVisit/addResurvey/addMotion.vue'
import {
	RESURVEY,
	MOTION,
	NEW_MOTION,
	WEI_JUE,
	REVISIT_FINISH,
} from '@/utils/const'

@Component({
	components: {
		ActionCol,
		RevisitAction,
		addResurvey,
		addMotion,
	},
})
export default class WPInjuryItem extends Vue {
	private adding = false
	private columns = columns
	private data: any = []
	private RESURVEY = RESURVEY
	private MOTION = MOTION
	private NEW_MOTION = NEW_MOTION
	private WEI_JUE = WEI_JUE
	private REVISIT_FINISH = REVISIT_FINISH
	private addVisible = false
	private clickedRow: any = {}

	@Prop({})
	private index!: string

	@Prop({})
	private isOther!: boolean

	@Prop({})
	private injury!: any

	@Watch('injury', { immediate: true })
	private onInjuryChange() {
		// 获取伤者列表
		this.getList()
	}

	private get taskAuthObj() {
		return {
			cancelAudit: this.$auth('wpDetail:auditCancelTask'),
			audit: this.$auth('wpDetail:auditTask'),
			resend: this.$auth('wpDetail:resend'),
		}
	}

	private get revisitAuthObj() {
		return {
			ShouHouOp: this.$auth('returnVisitList:operation'),
			WeiJueOp: this.$auth('wpDetail:operation'),
			ShouHouStart: this.$auth('returnVisitDetail:begin'),
			WeiJueStart: this.$auth('wpDetail:begin'),
			addResurvey: this.$auth('wpDetail:addResurvey'),
			addMotion: this.$auth('wpDetail:addMotion'),
			trackDetail: this.$auth('wpDetail:trackDetail'),
		}
	}

	private get canAddRevisit() {
		// 是否可新增未决回访
		const wholeProcessList = (this.injury && this.injury.wholeProcessList) || []
		return (
			wholeProcessList.length > 0 &&
			wholeProcessList.some((item: any) => {
				return !!item.wholeProcessOrderId
			})
		)
	}

	private get canStopProcess() {
		// 0 案件跟进中， 1 已完成
		const wholeProcessList = (this.injury && this.injury.wholeProcessList) || []
		return (
			wholeProcessList.length > 0 &&
			wholeProcessList.some((item: any) => {
				return item.wholeProcessIsDone === '0'
			})
		)
	}

	private get stopReasonList() {
		const wholeProcessList = (this.injury && this.injury.wholeProcessList) || []
		return wholeProcessList.reduce((arr: any[], wp: any) => {
			if (wp.endType) {
				arr.push({
					orderNo: wp.orderNo,
					endType: wp.endType,
					reason: wp.reason,
				})
			}
			return arr
		}, [])
	}

	private get commonStatusMap(): any {
		return Object.assign(
			{},
			this.$store.state.setting.orderStatusMap,
			this.$store.state.setting.conOrderStatusMap
		)
	}

	private showModal(row: any) {
		this.addVisible = true
		this.clickedRow = row
	}

	private goToAiiTaskDetail(row: any) {
		return `/AiiTasks/TasksDetail/${row.relationTaskId}/${row.relationTaskType}`
	}

	public getTaskType(row: any) {
		// relationType 1 当前任务为订单 2 当前任务为未决任务
		if (row.relationType === '1') {
			return getTaskType(
				{
					taskType: row.relationTaskType,
					subTaskType: row.relationSubTaskType,
				},
				this.$store.state.setting
			)
		} else if (row.relationType === '2') {
			return '未决回访'
		} else {
			return '-'
		}
	}

	private toAddPendingTask(injury: any) {
		const wholeProcessList = injury.wholeProcessList || []
		if (wholeProcessList.length > 1) {
			this.$emit('toAddPendingTask', wholeProcessList)
		} else {
			this.addPendingTask(
				wholeProcessList[0] && wholeProcessList[0].wholeProcessOrderId
			)
		}
	}

	private addPendingTask(orderId: string) {
		if (!orderId) {
			return console.error('选中项的orderId不存在')
		}

		this.adding = true
		RevisitApi.addTrackTask(orderId)
			.then((res: any) => {
				this.$multiTab.close('/returnVisit/collectPendingInfo')
				this.$ls.set('pendingTaskId', res.data)
				this.$nextTick(() => {
					this.$multiTab.open('/returnVisit/collectPendingInfo')
				})
			})
			.finally(() => {
				this.adding = false
			})
	}

	private toStopProcess(injury: any) {
		const wholeProcessList = injury.wholeProcessList || []
		this.$emit(
			'toStopProcess',
			wholeProcessList.filter((item: any) => item.wholeProcessIsDone === '0')
		)
	}

	private getList() {
		WholeProcessApi.getInjuryTaskList(this.injury.injuredId).then(
			(res: any) => {
				this.data = (res.data && res.data.retList) || []
			}
		)
	}
}
